import { useLang } from "../../i18n/LanguageContext";

const icons = ["fa-fire-extinguisher","fa-bell","fa-bolt","fa-bolt-lightning","fa-network-wired","fa-faucet-drip"];

export default function HeroShortcuts() {
  const { t } = useLang();
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 pt-12 max-w-4xl mx-auto">
      {t.services.tabs.map((item, i) => (
        <button
          key={i}
          onClick={() => { document.querySelector("#services")?.scrollIntoView({ behavior:"smooth" }); }}
          className="p-4 glass-card rounded cursor-pointer hover:border-[#F28C18]/40 hover:-translate-y-0.5 transition-all duration-200 text-center space-y-2 group"
        >
          <i className={`fas ${icons[i]} text-[#F28C18] text-lg group-hover:scale-110 transition-transform`} />
          <div className="text-[10px] uppercase font-black tracking-wider text-zinc-400 group-hover:text-white transition-colors leading-tight">{item}</div>
        </button>
      ))}
    </div>
  );
}
